import { render } from "./AddressListItem.vue?vue&type=template&id=4d2cfbc2&scoped=true"
import script from "./AddressListItem.vue?vue&type=script&lang=js"
export * from "./AddressListItem.vue?vue&type=script&lang=js"

import "./AddressListItem.vue?vue&type=style&index=0&id=4d2cfbc2&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2cfbc2"]])

export default __exports__